/**
 * Navegación de la plataforma Analytics.
 * status: live | soon (soon solo si aún no hay página)
 * PLATFORM_NAV = métricas oficiales.
 * ANA_NAV = centro operativo multicanal de Ana.
 * OLD_NAV = vistas anteriores.
 * LAB_NAV = vistas experimentales.
 */

export const OLD_LEADS_CHILDREN = [
  { id: 'old-leads-resumen', path: '/old/leads', label: 'Resumen', end: true },
  { id: 'old-leads-calidad', path: '/old/leads/calidad', label: 'Calidad' },
  { id: 'old-leads-embudo', path: '/old/leads/embudo', label: 'Embudo comercial' },
  { id: 'old-leads-conversion', path: '/old/leads/conversion', label: 'Conversión' },
  { id: 'old-leads-tendencias', path: '/old/leads/tendencias', label: 'Tendencias' },
  { id: 'old-leads-inventario', path: '/old/leads/inventario-kommo', label: 'Contactos Kommo' }
];

export const PLATFORM_NAV = [
  { id: 'leads', path: '/', label: 'Leads por fecha', status: 'live' },
  { id: 'cohorte-detalle', path: '/cohorte-detalle', label: 'Leads · detalle', status: 'live' },
  { id: 'marketing', path: '/meta', label: 'Meta Ads', status: 'live' },
  { id: 'fugas-meta', path: '/fugas-meta', label: 'Fugas Meta', status: 'live' },
  { id: 'trazabilidad-leads', path: '/trazabilidad-leads', label: 'Historial de leads', status: 'live' },
  { id: 'configuracion', path: '/configuracion', label: 'Configuración', status: 'live', end: true },
  { id: 'mapeo-reunion', path: '/configuracion/reunion', label: 'Estados reunión', status: 'live' }
];

export const ANA_NAV = [
  { id: 'ana-global', path: '/ana-actividad', label: 'Global', status: 'live', end: true },
  { id: 'ana-instagram', path: '/ana-actividad/instagram', label: 'Instagram', status: 'live' },
  { id: 'ana-facebook', path: '/ana-actividad/facebook', label: 'Facebook', status: 'live' },
  { id: 'ana-whatsapp', path: '/ana-actividad/whatsapp', label: 'WhatsApp', status: 'live' },
  { id: 'ana-email', path: '/ana-actividad/email', label: 'Correo', status: 'live' },
  { id: 'ana-canales', path: '/ana-canales', label: 'Canales / modos', status: 'live' },
  { id: 'instagram-automatizaciones', path: '/instagram-automatizaciones', label: 'Automatizaciones IG', status: 'live' }
];

export const OLD_NAV = [
  { id: 'old-resumen', path: '/old', label: 'Resumen', status: 'live', end: true },
  { id: 'old-leads', path: '/old/leads', label: 'Leads', status: 'live', children: OLD_LEADS_CHILDREN },
  { id: 'old-comercial', path: '/old/comercial', label: 'Comercial', status: 'live' },
  { id: 'old-reuniones', path: '/old/reuniones', label: 'Reuniones', status: 'live' },
  { id: 'old-reservas', path: '/old/reservas', label: 'Reservas', status: 'live' },
  { id: 'old-proyectos', path: '/old/proyectos', label: 'Proyectos', status: 'live' },
  { id: 'old-ejecutivos', path: '/old/ejecutivos', label: 'Ejecutivos', status: 'live' }
];

export const LAB_NAV = [
  { id: 'lab-atencion', path: '/lab/atencion', label: 'Atención ahora', status: 'live' },
  { id: 'lab-tracker', path: '/lab/tracker', label: 'Tracker operativo', status: 'live' },
  { id: 'lab-metas', path: '/lab/metas', label: 'Metas (borrador)', status: 'live' },
  { id: 'lab-definiciones', path: '/lab/definiciones', label: 'Comparar definiciones', status: 'live' }
];
